module.exports = __webpack_public_path__ + "static/media/building-profile.b539cbb4.svg";